var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { IScope, translate } from 'angular';
import { IStateService } from 'angular-ui-router';
import { Component } from 'decorators';
import template from './headerCounterApplication.html';
import './headerCounterApplication.scss';
let HeaderCounterApplicationComponent = class HeaderCounterApplicationComponent {
    static $inject = ['$state', '$translate', '$scope'];
    constructor($state, $translate, $scope) {
        'ngInject';
        this.$state = $state;
        this.$translate = $translate;
        this.$scope = $scope;
    }
};
HeaderCounterApplicationComponent.$inject = ['$state', '$translate', '$scope'];
HeaderCounterApplicationComponent = __decorate([
    Component({
        template,
        bindings: {
            contacts: '<',
            counterTotal: '<',
            checkedContacts: '<',
            headerMessage: '<',
            checkAllApplications: '&',
            uncheckAllApplications: '&',
            counterRouter: '<',
            counterBuilder: '<',
            stepOneVisible: '<',
            stepTwoVisible: '<',
            stepThreeVisible: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof IStateService !== "undefined" && IStateService) === "function" ? _a : Object, typeof (_b = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _b : Object, typeof (_c = typeof IScope !== "undefined" && IScope) === "function" ? _c : Object])
], HeaderCounterApplicationComponent);
export { HeaderCounterApplicationComponent };
